import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import FormatPrice from '@shared/containers/FormatPrice';
import messages from '../messages';
import PlusAmountWrapper from './PlusAmountWrapper';
import PriceLineThrough from './PriceLineThrough';

function DeliveryAmountPlus({
  finalPricePlus,
  originalPricePlus,
  desktopMode,
  isPickupHeader,
}) {
  if (finalPricePlus === 0) return null;
  return (
    <PlusAmountWrapper
      desktopMode={desktopMode}
      isPickupHeader={isPickupHeader}
    >
      <FormatPrice value={finalPricePlus}>
        {price => (
          <FormattedMessage
            {...(desktopMode
              ? messages.finalPricePlusDesktop
              : messages.finalPricePlusMobile)}
            values={{ finalPricePlus: price }}
          />
        )}
      </FormatPrice>
      <PriceLineThrough
        desktopMode={desktopMode}
        isPickupHeader={isPickupHeader}
      >
        <FormatPrice value={originalPricePlus}>
          {price => (
            <FormattedMessage
              {...messages.originalPricePlus}
              values={{ originalPricePlus: price }}
            />
          )}
        </FormatPrice>
      </PriceLineThrough>
    </PlusAmountWrapper>
  );
}

DeliveryAmountPlus.propTypes = {
  finalPricePlus: PropTypes.number.isRequired,
  originalPricePlus: PropTypes.number.isRequired,
  desktopMode: PropTypes.bool,
  isPickupHeader: PropTypes.bool,
};

export default memo(DeliveryAmountPlus);
